module.exports = __webpack_public_path__ + "92a7c542c1dbbe2a969de2956e5aa23d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_2023_chart.png
// module id = 1738
// module chunks = 0